import { TAnswersState, TFormContext } from '../types/internal';
import { EAnswerField, TFormStoreData } from '../../../types/form';

/**
 * Утверждает что переданный строковый ключ является валидным ключом для стейта ответов
 * */
function _assertKeyIsAnswersField(key: string): key is EAnswerField {
  return Object.values(EAnswerField).includes(key as EAnswerField);
}

/**
 * Парсит переданный набор параметров в валидный стейт ответов
 * */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _parsePredefinedAnswers = <T extends { [key: string]: any }>(params: T): Partial<TAnswersState> => {
  return Object.keys(params).reduce((acc, key) => {
    if (_assertKeyIsAnswersField(key) && params[key]) {
      acc[key] = {
        answerField: key,
        value: params[key],
      };
    }

    return acc;
  }, {} as Partial<TAnswersState>);
};

/**
 * Выполняет предустановку части стейта формы из переданного поля userData в форме из API
 * Сохраняет в внутренний стейт useFormController список пропускаемых шагов
 * */
export const presetInitialAnswersState = (formContext: TFormContext, formData: TFormStoreData) => {
  const { setAnswersState, setStepsToSkip } = formContext;
  const { userData, skipSteps } = formData;

  if (!userData) {
    return;
  }

  const partialAnswersState = _parsePredefinedAnswers(userData);

  setAnswersState(prevState => ({
    ...prevState,
    ...partialAnswersState,
  }));

  setStepsToSkip(skipSteps);
};
